// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { OverlayScrollbars } from "overlayscrollbars";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { trackScrollPos } from "../../../../../app/init/init_pageScrollbar";

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_modals", inline: true, disabled: false };
const msgs = {
  start: ["init. modals"],
  end: ["init. modals", "init. success"],
  no_el: ["init. modals", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_modals() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { modals_project } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);
  if (modals_project === undefined) return this.cancel_featInit(msgs.no_el);
  if (modals_project.every((el) => !this.validate_refEl(el))) return this.cancel_featInit(msgs.no_el);

  /////// Modal features init. ///////
  ////////////////////////////////////

  modals_project.forEach((m) => {
    //// Header height /////
    ////////////////////////

    const el_header = m.querySelector("[data-ref='header']");
    if (el_header) {
      const h_header = el_header.getBoundingClientRect().height;
      m.style.setProperty("--h-header", `${h_header}px`);
    }

    ////// Close btn. //////
    ////////////////////////

    const closeBtn = m.querySelector("[data-ref='btn_close']");
    if (closeBtn) closeBtn.addEventListener("click", () => this.setState({ activeGridItem: "null" }));

    ////// Scrollbar ///////
    ////////////////////////

    const inst_os = OverlayScrollbars(
      m,
      { scrollbars: { theme: "os-theme-cef" } },
      {
        scroll(inst) {
          trackScrollPos(m, inst);
        },
      }
    );
  });

  ///////////// Conclude /////////////
  ////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
